import ActionTypes from "../../../../constants/ActionTypes";
import { IGetProductSuggestionsAction, IPayloadGetProductSuggestionsAction } from "./types";

export function getProductSuggestions(payload: IPayloadGetProductSuggestionsAction): IGetProductSuggestionsAction {
  return {
    type: ActionTypes.PRODUCT.GET_PRODUCT_SUGGESTIONS,
    payload,
  };
}

export function setProductSuggesstions(productSuggestions: object) {
  return {
    type: ActionTypes.PRODUCT.SET_PRODUCT_SUGGESTIONS,
    payload: productSuggestions
  };
}

export function enrichProductSuggestionsAction(payload: any): any {
  return {
    type: ActionTypes.PRODUCT.ENRICH_PRODUCT_SUGGESTIONS,
    payload,
  };
}
